import Button from "common/components/Button/Button"
import DireccionInputs from "common/components/FormikFields/DireccionInputs"
import FormikAutoComplete from "common/components/FormikFields/FormikAutoComplete"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import useRazonSocialAndCif from "common/hooks/useRazonSocialAndCif"
import * as Validations from "common/utils/formValidations"
import { withFormik } from "formik"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import * as Yup from "yup"
import { newDocumentoSelector } from "../redux/selectors/newDocumentoSelectors"
import { setLibrado } from "../redux/slices/newDocumentoSlice"

const DatosCliente = ({
  values,
  handleSubmit,
  onHide,
  setFieldValue,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const { razonesSociales, cifs, getByCifOrRazonSocial } =
    useRazonSocialAndCif()

  const handleOnSelectRazonSocial = (e: $TSMigrationFixMe) => {
    setFieldValue("razonSocial", e.value)
    // @ts-expect-error TS(2345): Argument of type 'any' is not assignable to parame...
    const indexRazonSocial = razonesSociales.indexOf(e.value)
    setFieldValue("cif", cifs[indexRazonSocial])
  }

  const handleOnSelectCif = (e: $TSMigrationFixMe) => {
    setFieldValue("cif", e.value)
    // @ts-expect-error TS(2345): Argument of type 'any' is not assignable to parame...
    const indexCif = cifs.indexOf(e.value)
    setFieldValue("razonSocial", razonesSociales[indexCif])
  }

  const handleOnChangeTelefono = (e: $TSMigrationFixMe) => {
    const value = e.target.value.replace(/[^0-9]/g, "")
    if (value.length > 9) return
    setFieldValue("telefono", value)
  }

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
      data-id='form-factura-cliente'
      style={{ paddingBottom: "60px" }}
    >
      <div className='mb-2 p-fluid'>
        <div className='mb-2 p-fluid'>
          <div className='p-field'>
            <label htmlFor='cif'>{t("crear.facturaRec.modal.cifLabel")}</label>

            <FormikAutoComplete
              autoFocus
              id='cif'
              name='cif'
              maxLength={9}
              completeMethod={(query: $TSMigrationFixMe) =>
                getByCifOrRazonSocial("cif", query)
              }
              suggestions={cifs}
              onSelect={handleOnSelectCif}
            />
          </div>
        </div>

        <div className='p-field'>
          <label htmlFor='razonSocial'>
            {t("crear.facturaRec.modal.razonSocialLabel")}
          </label>

          <FormikAutoComplete
            id='razonSocial'
            name='razonSocial'
            completeMethod={(query: $TSMigrationFixMe) =>
              getByCifOrRazonSocial("razonSocial", query)
            }
            suggestions={razonesSociales}
            onSelect={handleOnSelectRazonSocial}
          />
        </div>
      </div>

      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='direccion'>
            {" "}
            {t("crear.facturaRec.modal.directionLabel")}
          </label>
          <FormikInputText
            id='direccion'
            name='direccion'
          />
        </div>
      </div>

      <div className='mb-2 p-fluid'>
        <DireccionInputs
          initialCodigoPostal={values.cp}
          setFieldValue={setFieldValue}
          cpValue={values.cp}
          poblacionValue={values.poblacion}
        />
      </div>

      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='email'>{t("crear.facturaRec.modal.mailLabel")}</label>

          <FormikInputText
            id='email'
            name='email'
          />
        </div>
      </div>

      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='telefono'>
            {t("crear.facturaRec.modal.tlfLabel")}
          </label>

          <FormikInputText
            autoComplete='nope'
            id='telefono'
            name='telefono'
            onChange={handleOnChangeTelefono}
          />
        </div>
      </div>

      <input
        type='text'
        autoComplete='on'
        value=''
        style={{
          display: "none",
          opacity: 0,
          position: "absolute",
          left: "-100000px",
        }}
        readOnly
      />

      <div className='d-flex justify-content-end align-items-center'>
        <a
          href='#'
          className='mr-3 link-cancel'
          onClick={onHide}
        >
          {t("crear.facturaRec.modal.cancelButton")}
        </a>

        <Button
          type='submit'
          className='!tw-bg-primary'
        >
          {t("crear.facturaRec.modal.addButton")}
        </Button>
      </div>
    </form>
  )
}

const validate = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    razonSocial: Validations.validateRazonSocial(t),
    cif: Validations.validateCif(t),
    poblacion: Validations.validatePoblacion(t),
    cp: Validations.validateCodigoPostal(t),
    direccion: Validations.validateDireccion(t),
    email: Validations.validateEmail(t),
    telefono: Validations.validateTelefono(t),
  })

const CreateWithFormik = withFormik({
  validationSchema: ({ t }: $TSMigrationFixMe) => validate(t),
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'props' does not exist on type '{}'.
  validate: (values, { props }) => {
    const errors = {}
    if (!values.poblacionId) {
      // @ts-expect-error TS(2339): Property 'poblacion' does not exist on type '{}'.
      errors.poblacion = `${props.t("errors.selectedPoblation")}`
    }
    return errors
  },
  // @ts-expect-error TS(2339): Property 'librado' does not exist on type '{}'.
  mapPropsToValues: ({ librado }) => ({
    razonSocial: librado?.razonSocial || "",
    cif: librado?.cif || "",
    direccion: librado?.direccion || "",
    email: librado?.email || "",
    telefono: librado?.telefono || null,
    cp: librado?.cp || null,
    poblacion: librado?.poblacion || "",
    provincia: librado?.provincia || "",
    poblacionId: librado?.poblacionId || "",
    provinciaId: librado?.provinciaId || "",
    codigoIne: librado?.codigoIne || "",
  }),
  handleSubmit: (values, { props }) => {
    // @ts-expect-error TS(2339): Property 'setLibrado' does not exist on type 'obje...
    props.setLibrado(values)
    // @ts-expect-error TS(2339): Property 'onHide' does not exist on type 'object'.
    props.onHide()
  },
})(DatosCliente)

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  setLibrado: (librado: $TSMigrationFixMe) => {
    dispatch(setLibrado(librado))
  },
})

const mapStateToProps = (state: $TSMigrationFixMe) => ({
  librado: newDocumentoSelector(state).librado,
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateWithFormik)
